import { requestPush } from '../../push-notifications/PushNotificationsProvider'

export function RequestPushNotifications() {
  requestPush()
}
